import { clsx } from '@alexis/helpers/clsx';
import React from 'react';
import { useSelector } from 'react-redux';

import AfternoonIcon from '@icons/afternoon.svg';
import EarlyMorningIcon from '@icons/early_morning.svg';
import MorningIcon from '@icons/morning.svg';
import NightIcon from '@icons/night.svg';

import { getTranslationsState } from '@redux/selectors';

import styles from './FlightTimeFilter.module.scss';

interface FlightTimeFilterProps {
  selectedTimeBlocks: Array<FlightFilterTimeBlock>;
  onTimeBlocksToggle: (timeBlock: FlightFilterTimeBlock) => void;
}

const timeBlocks: Array<{
  id: FlightFilterTimeBlock;
  Icon: React.FC<React.SVGAttributes<SVGElement>>;
  translationKey: string;
}> = [
  {
    id: '0000-0600',
    Icon: EarlyMorningIcon,
    translationKey: 'time_segment_early_morning',
  },
  {
    id: '0600-1200',
    Icon: MorningIcon,
    translationKey: 'time_segment_morning',
  },
  {
    id: '1200-1800',
    Icon: AfternoonIcon,
    translationKey: 'time_segment_afternoon',
  },
  {
    id: '1800-2400',
    Icon: NightIcon,
    translationKey: 'time_segment_evening',
  },
];

const FlightTimeFilter: React.FC<FlightTimeFilterProps> = ({
  selectedTimeBlocks,
  onTimeBlocksToggle,
}) => {
  const translations = useSelector(getTranslationsState);

  return (
    <div className={styles.container} data-testid='flight-time-filter'>
      {timeBlocks.map(({ id, Icon, translationKey }) => {
        return (
          <div
            key={id}
            className={clsx(styles.timeBlock, selectedTimeBlocks.includes(id) && styles.selected)}
            onClick={() => onTimeBlocksToggle(id)}
          >
            <Icon className={styles.icon} />

            {translations[translationKey]}
          </div>
        );
      })}
    </div>
  );
};

export default FlightTimeFilter;
